/**
 * Created by odeds on 12/29/15.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var ApiKeyModel = require("manager-models/data-sources/api-keys/ApiKeyModel");
    var RevisionedCollection = require("collections/RevisionedCollection");
    var ApiResources = require("assets/data/apiResources.json");

    var NAME = "ApiKeysCollection";

    var ApiKeysCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ApiKeysCollection = RevisionedCollection.extend({
            model: ApiKeyModel,
            resource: ApiResources.ApiKeyManager.ApiKeys,
            name: NAME,
            add: function(models, options){
                return RevisionedCollection.prototype.add.call(this, models.items, options);
            },
            getModelByApiKey: function(apiKey){
                var result = _.find(this.models, function(model){
                    return model.get(ApiKeyModel.KEYS.APIKEY) === apiKey;
                });
                return result;
            }
        });

    }

    LE.module("LEManager", moduleDefinition);

    ApiKeysCollection.NAME = NAME;

    return ApiKeysCollection;
});
